@if (inited) {
  <div>
    <sm-toolbar>
      <p-button icon="fas fa-save" label="Speichern" (onClick)="save()">
      </p-button>
    </sm-toolbar>
    <div class="card">
      <sm-tab-view>
        <sm-tab header="Leistungsnachweistypen">
          <p-table class="p-datatable-gridlines" [value]="settings.examTypes">
            <ng-template pTemplate="header">
              <tr>
                <th>Titel</th>
                <th style="width: 6rem; text-align: center">
                  <p-button class="p-button-secondary" icon="fas fa-plus" (onClick)="addExamType()"></p-button>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-examType let-index="rowIndex">
              <tr [pSelectableRow]="index">
                <td  pEditableColumn>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <input pInputText [(ngModel)]="examType.title" (onFocus)="_GuiUtils.selectAll($event)">
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{examType.title}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td style="text-align: center">
                  <p-button class="p-button-secondary" icon="fas fa-trash" (onClick)="deleteExamType(index)"></p-button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </sm-tab>
        @if (settings.type == _SchoolType.secondary) {
          <sm-tab header="Wochenstunden">
            <p-table class="p-datatable-gridlines" [value]="domains">
              <ng-template pTemplate="header">
                <tr>
                  <th>Fach</th>
                  @for (grade of gradeLevels; track grade) {
                    <th style="width: 7%">{{grade}}</th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-domain let-index="rowIndex">
                <tr [pSelectableRow]="index">
                  <td>{{domain}}</td>
                  @for (grade of gradeLevels; track grade) {
                    <td pEditableColumn>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber [(ngModel)]="domainHoursPerWeek[domain + '|' + grade].count" [min]="0" [max]="9" [inputStyle]="{'width': '50px'}" (onFocus)="_GuiUtils.selectAll($event)"></p-inputNumber>
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{domainHoursPerWeek[domain + '|' + grade].count > 0 ? domainHoursPerWeek[domain + '|' + grade].count : ''}}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                  }
                </tr>
              </ng-template>
            </p-table>
          </sm-tab>
          <sm-tab header="gGN-Gewichtung">
            <p-message class="mb-3" severity="warn">
              Sobald mindestens ein Wert gespeichert ist, wird diese Matrix verwendet. Leere Felder werden mit 50 % gewichtet. Ohne gespeicherte Matrix bleibt für ältere Schuljahre die bisherige Gewichtung anhand der Wochenstunden aktiv.
            </p-message>
            <p-table class="p-datatable-gridlines" [value]="gradeLevels">
              <ng-template pTemplate="header">
                <tr>
                  <th rowspan="3">Klassenstufe</th>
                  <th colspan="9" class="text-center">Schullaufbahn</th>
                </tr>
                <tr>
                  <th colspan="3" class="text-center">ohne</th>
                  <th colspan="3" class="text-center">Regio/Br</th>
                  <th colspan="3" class="text-center">gym</th>
                </tr>
                <tr>
                  @for (schoolCareer of ggnWeightingSchoolCareers; track schoolCareer) {
                    <th class="text-center">1 gGN</th>
                    <th class="text-center">2 gGN</th>
                    <th class="text-center">ab 3 gGN</th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-grade>
                <tr>
                  <td>{{grade}}</td>
                  @for (schoolCareer of ggnWeightingSchoolCareers; track schoolCareer) {
                    @for (ggnCount of ggnCounts; track ggnCount) {
                      <td class="text-center" pEditableColumn>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <p-inputNumber [(ngModel)]="ggnWeightings[getGgnWeightingKey(grade, schoolCareer, ggnCount)].factor" [min]="0" [max]="100" [maxFractionDigits]="6" suffix=" %" [inputStyle]="{'width': '90px'}" (onFocus)="_GuiUtils.selectAll($event)"></p-inputNumber>
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{ggnWeightings[getGgnWeightingKey(grade, schoolCareer, ggnCount)].factor == null ? '' : (ggnWeightings[getGgnWeightingKey(grade, schoolCareer, ggnCount)].factor | number:'1.0-6') + ' %'}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                    }
                  }
                </tr>
              </ng-template>
            </p-table>
          </sm-tab>
        }
        <sm-tab header="Durchschnittsberechnung">
          @if (examTypeAdded) {
            <p-message severity="warn">
              Es wurde mindestens ein Leistungsnachweistyp neu eingefügt. Bitte speichern Sie einmal die Einstellungen, um die Faktoren für den neuen Typ editieren zu können
            </p-message>
          }
          <sm-toolbar class="col-12">
            Kompetenzbereich:
            <p-select class="width300" id="domain" [options]="domains"
              [(ngModel)]="selectedDomain" (onChange)="changeSelectedDomain()">
            </p-select>
            <p-button icon="fas fa-save" label="Zu anderen Kompetenzbereichen kopieren" (onClick)="copyExamTypeFactors()">
            </p-button>
          </sm-toolbar>
          @if (selectedDomainSettings != null) {
            <p-table class="p-datatable-gridlines" [value]="selectedDomainSettings.examTypeFactors" sortField="examType.title">
              <ng-template pTemplate="header">
                <tr>
                  <th>Art des Leistungsnachweises</th>
                  <th style="width:100px">Gewichtung</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-examTypeFactor let-index="rowIndex">
                <tr [pSelectableRow]="index">
                  <td>{{examTypeFactor.examType.title}}</td>
                  <td  pEditableColumn>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-inputNumber [(ngModel)]="examTypeFactor.factor" [min]="0" [max]="100" [inputStyle]="{'width': '50px'}" (onFocus)="_GuiUtils.selectAll($event)"></p-inputNumber>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{examTypeFactor.factor}}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          }
        </sm-tab>
        <sm-tab header="Bewertungsübersicht">
          <sm-toolbar class="col-12">
            Klassenstufe:
            <p-select class="width100" id="grade" [options]="gradeLevels"
              [(ngModel)]="selectedGradeLevel" (onChange)="changeSelectedGradeLevel()">
            </p-select>
            <p-button icon="fas fa-save" label="Zu anderen Klassenstufen kopieren" (onClick)="copyMarkTranslation()">
            </p-button>
            <span class="ml-3">Art der Noteneingabe:</span>
            <p-select class="width300" id="gradeType" [options]="[{label: 'Prozentwerte', value: _GradeType.percent}, {label: 'Schulnoten', value: _GradeType.oneToSix}]"
              [(ngModel)]="selectedGradeSettings.gradeType">
            </p-select>
            @if (selectedGradeSettings.gradeType == _GradeType.percent) {
              <p-checkbox class="option ml-3" appLabel="Noten zusätzlich anzeigen" name="useTextualGrades" [(ngModel)]="selectedGradeSettings.useTextualGrades" [binary]=true></p-checkbox>
            }
            <p-checkbox class="option ml-3" appLabel="Abweichend für Diktate" name="useDictationTranslation" [(ngModel)]="selectedGradeSettings.useDictationTranslation" [binary]=true></p-checkbox>
          </sm-toolbar>
          @for (forDictation of _Arrays.withoutNull([false, selectedGradeSettings.useDictationTranslation ? true : null]); track forDictation) {
            @if (selectedGradeSettings.useDictationTranslation) {
              <h3>{{forDictation ? 'Für Diktate' : 'Allgemein'}}</h3>
            }
            @if (selectedGradeSettings != null) {
              <p-table class="p-datatable-gridlines" [value]="forDictation ? markTranslationDictation : markTranslationGeneral" sortField="fromPercent">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width:300px">erreichtes Ergebnis in %</th>
                    <th>Bewertung</th>
                    @if (selectedGradeSettings.useTextualGrades) {
                      <th>Note</th>
                    }
                    <th style="width: 6rem; text-align: center">
                      <p-button class="p-button-secondary" icon="fas fa-plus" (onClick)="addMarkTranslation(forDictation)"></p-button>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-mt let-index="rowIndex">
                  <tr [pSelectableRow]="mt">
                    <td pEditableColumn>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber [(ngModel)]="mt.fromPercent" [min]="0" [max]="100" [inputStyle]="{'width': '50px'}" (onFocus)="_GuiUtils.selectAll($event)"></p-inputNumber>
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{mt.fromPercent}}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td pEditableColumn>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <input pInputText [(ngModel)]="mt.text" (onFocus)="_GuiUtils.selectAll($event)">
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{mt.text}}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    @if (selectedGradeSettings.useTextualGrades) {
                      <td pEditableColumn>
                        <p-cellEditor>
                          <ng-template pTemplate="input">
                            <input pInputText [(ngModel)]="mt.textualGrade" (onFocus)="_GuiUtils.selectAll($event)">
                          </ng-template>
                          <ng-template pTemplate="output">
                            {{mt.textualGrade}}
                          </ng-template>
                        </p-cellEditor>
                      </td>
                    }
                    <td style="text-align: center">
                      <p-button class="p-button-secondary" icon="fas fa-trash" (onClick)="deleteMarkTranslation(index, forDictation)"></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            }
          }
        </sm-tab>
        <sm-tab header="Anzeigeoptionen">
          <sm-form [form]="formOptions">
          </sm-form>
        </sm-tab>
      </sm-tab-view>
    </div>
  </div>
}
